import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Flex, Heading, ScrollArea, Table, Button, Spinner } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';

import { Paginator } from 'shared/components/pagination';
import { ArrowDownwardIcon, ArrowUpwardIcon } from 'shared/icons';

import { SliderActionsMenu } from './slider-actions-menu';
import { SliderManagerFilters } from './slider-manger-filters';
import { useSliderManager } from './slider-manager.provider';

import APNavBar from 'Components/adminpanel/Elements/APNavBar';
import APSidebar from 'Components/adminpanel/APSidebar/APSidebar';

import './slider-manager.scss';
import { sl } from 'date-fns/locale';
import { TableLoaderOverlay } from './table-loader-overlay';

function SliderManagerView() {
   const navigate = useNavigate();
   const sliderManager = useSliderManager();
   React.useEffect(() => {
      sliderManager.loadSlider();
   }, []);

   return (
      <>
         <APNavBar />
         <Box pt="80px" className="slider-manager">
            <Flex width="270px" minWidth="270px">
               <APSidebar />
            </Flex>
            <Box className="slider-manager__content">
               <Flex py="1" mx="3" justify="between">
                  <Heading as="h1" weight="medium">
                     Employer Logo List
                  </Heading>
                  <Button size="3" onClick={() => navigate('/admin/users/addhomepageslider')}>
                     Add Employer To Slider
                  </Button>
               </Flex>

               <SliderManagerFilters />

               <ScrollArea scrollbars="both" type="always" className="slider-manager__scroll-area">
                  <Box p="3">
                     <Table.Root size="3" layout="auto" variant="surface">
                        <Table.Header>
                           <Table.Row>
                              <Table.ColumnHeaderCell>
                                 <Flex gap="1" align="center">
                                    <span className="header-label">Company Name </span>
                                    <button
                                       className="sort-trigger"
                                       onClick={() => {
                                          sliderManager.onSortBy('company_name');
                                       }}
                                    >
                                       {
                                          {
                                             asc: <ArrowDownwardIcon width={18} height={18} />,
                                             desc: <ArrowUpwardIcon width={18} height={18} />,
                                          }[sliderManager.direction]
                                       }
                                    </button>
                                 </Flex>
                              </Table.ColumnHeaderCell>
                              <Table.ColumnHeaderCell>
                                 <Flex gap="1" align="center">
                                    <span className="header-label">Employer ID</span>
                                    <button
                                       className="sort-trigger"
                                       onClick={() => {
                                          sliderManager.onSortBy('employer_id');
                                       }}
                                    >
                                       {
                                          {
                                             asc: <ArrowDownwardIcon width={18} height={18} />,
                                             desc: <ArrowUpwardIcon width={18} height={18} />,
                                          }[sliderManager.direction]
                                       }
                                    </button>
                                 </Flex>
                              </Table.ColumnHeaderCell>
                              <Table.ColumnHeaderCell>
                                 <Flex gap="1" align="center">
                                    <span className="header-label">Email</span>
                                    <button
                                       className="sort-trigger"
                                       onClick={() => {
                                          sliderManager.onSortBy('email_address');
                                       }}
                                    >
                                       {
                                          {
                                             asc: <ArrowDownwardIcon width={18} height={18} />,
                                             desc: <ArrowUpwardIcon width={18} height={18} />,
                                          }[sliderManager.direction]
                                       }
                                    </button>
                                 </Flex>
                              </Table.ColumnHeaderCell>

                              <Table.ColumnHeaderCell>
                                 <Flex>
                                    <span className="header-label"> Logo </span>
                                 </Flex>
                              </Table.ColumnHeaderCell>

                              <Table.ColumnHeaderCell >
                                    <Flex justify="center">
                                    <span className="header-label"> Order Number </span>
                                 </Flex>
                              </Table.ColumnHeaderCell>

                              <Table.ColumnHeaderCell>
                                 <Flex gap="1" align="center">
                                    <span className="header-label">Created</span>
                                    <button
                                       className="sort-trigger"
                                       onClick={() => {
                                          sliderManager.onSortBy('home_slider_created');
                                       }}
                                    >
                                       {
                                          {
                                             asc: <ArrowDownwardIcon width={18} height={18} />,
                                             desc: <ArrowUpwardIcon width={18} height={18} />,
                                          }[sliderManager.direction]
                                       }
                                    </button>
                                 </Flex>
                              </Table.ColumnHeaderCell>

                              <Table.ColumnHeaderCell justify="center">
                                 Action
                              </Table.ColumnHeaderCell>
                           </Table.Row>
                        </Table.Header>

                        <Table.Body>
                           <TableLoaderOverlay
                              show={sliderManager.loadSlidersState.status === 'pending'}
                              colSpan={7}
                           />

                           {sliderManager.sliders.map((slide) => {
                              return (
                                 <Table.Row key={slide.id}>
                                    <Table.Cell width="300px">{slide.company_name}</Table.Cell>
                                    <Table.Cell width="220px">{slide.employer_id}</Table.Cell>

                                    <Table.Cell>{slide.email_address}</Table.Cell>

                                    <Table.Cell>
                                       <div className="logo-cell-card">
                                          <img
                                             className="company-logo"
                                             width="100%"
                                             height="100%"
                                             src={slide.company_logo}
                                             alt="company logo"
                                          />
                                       </div>
                                    </Table.Cell>

                                    <Table.Cell width="140px" align="center">
                                       {slide.display_order}
                                    </Table.Cell>

                                    <Table.Cell width="150px">
                                       {slide.home_slider_created}
                                    </Table.Cell>

                                    <Table.Cell align="center" width="100px">
                                       <SliderActionsMenu slide={slide} />
                                    </Table.Cell>
                                 </Table.Row>
                              );
                           })}
                        </Table.Body>
                     </Table.Root>
                  </Box>
               </ScrollArea>
               <Flex className="slider-manager__pagination" py="2">
                  <Paginator
                     totalPages={sliderManager.totalPages}
                     currentPage={sliderManager.pagination.page}
                     onPageClick={(p) => {
                        sliderManager.pagination.setPage(p);
                     }}
                     setRange={(p) => {
                        console.log(p);
                        sliderManager.pagination.setRange(p);
                     }}
                     range={sliderManager.pagination.range}
                  />
               </Flex>
            </Box>
         </Box>
      </>
   );
}

export const SliderManager = observer(SliderManagerView);
